import { projectLayout } from '@atlassian/jira-project-layout/src/index.tsx';
import { composeLayouts, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { RightSidebars } from './ui/right-sidebars/index.tsx';

const rightSidebars = [RightSidebars];

export const polarisProjectLayout: Layout = composeLayouts(projectLayout, {
	rightSidebars,
});
